import logo from 'assets/images/Logo_INE.png';
import './FooterPortalPublico.scss';

export function FooterPortalPublico() {
  return (
    <div className="containerFooterPortal">
      <img src={logo} className="logoFooterPortal" alt="LogoFooterINE" />
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      <span style={{ textAlign: 'center' }}>
        Sistema de Consulta del Portal de Rendición de Cuentas y Resultados de Fiscalización | CAU{' '}
        <br />
        Compatibilidad óptima con Google Chrome
        <br />© Derechos Reservados, Instituto Nacional Electoral, México 1991 al 2024
      </span>
    </div>
  );
}
